import { byId } from '@/services/arrayUtility'
import { connectToActionHub, closeActionHubConnection, subscribe } from "@/services/actionHub"
import { list, canList } from "@/features/schemas/services/schemaApi";

function get(itemsById, id) {
    if(id == null) {
        return null;
    }

    if(typeof id !== "string") {
        id = id.toString();
    }

    return itemsById[id];
}

function getDefaultState() {
    return {
        staffMembers: [],
        staffMembersById: {},

        connection: null,
        subscription: null,
        isLoaded: false
    };
}

const refreshActionsByEntityKey = {
    staffMember: "refreshStaffMembers",
}

const refreshEntityKeys = Object.keys(refreshActionsByEntityKey);
const refreshActions = Object.values(refreshActionsByEntityKey);

const state = getDefaultState;

const actions = {
    async load({ commit, dispatch }) {
        const results = await Promise.allSettled(
            refreshActions.map(action => dispatch(action))
        );

        const failed = results.filter(r => r.status === "rejected");
        if (failed.length > 0) {
            dispatch(
                "alert/warning",
                "Some data couldn't be loaded. Please contact your administrator.",
                { root: true });
        }

        const connection = await connectToActionHub();
        const subscription = subscribe(
            messages => dispatch("receiveMessages", messages),
            refreshEntityKeys);

        commit("subscription", subscription);
        commit("connection", connection);
        commit("isLoaded", true);
    },

    async refreshStaffMembers({ commit, dispatch }) {
        // Wait for schema module to complete loading
        await dispatch('schema/loadCompletion', null, { root: true });
        if (!canList("staffMember")) {
            commit("staffMembers", []);
            return;
        }
        const staffMembers = (await list("staffMember", null, { sortBy: "name" })).items;
        commit("staffMembers", staffMembers);
    },

    async receiveMessages({ dispatch }, messages) {
        // Get the unique entity keys from the received messages and then dispatch any relevant
        // actions to refresh the data.
        const entityKeys = new Set(messages.map(m => m.entityKey));

        const promises = refreshEntityKeys
            .filter(entityKey => entityKeys.has(entityKey))
            .map(entityKey => dispatch(refreshActionsByEntityKey[entityKey]));

        await Promise.all(promises);
    },

    clear({ commit, state }) {
        state.subscription.unsubscribe();
        closeActionHubConnection(state.connection);
        commit("clear");
    }
};

const getters = {
    getStaffMember: (state) => (id) => get(state.staffMembersById, id)
};

const mutations = {
    staffMembers(state, staffMembers) {
        state.staffMembers = staffMembers;
        state.staffMembersById = byId(staffMembers);
    },
    connection(state, connection) {
        state.connection = connection;
    },
    subscription(state, subscription) {
        state.subscription = subscription;
    },
    isLoaded(state, value) {
        state.isLoaded = value;
    },
    clear(state) {
        Object.assign(state, getDefaultState());
    }
};

export const data = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
